import React from 'react';
import Intl from '@fx-ui/intl';
import { redirectToLogin } from '../../utils/login';

/**
 * 已有简道云账号？直接登录
 */
const LoginSwitch = () => {
    return (
        <div className="fx-login-switch">
            <span>{Intl.get('account.register.has.account')}</span>
            <span className="login-btn" onClick={redirectToLogin}>
                {Intl.get('account.register.signin')}
            </span>
        </div>
    );
};

export default LoginSwitch;
